/**
 * 运行时「业务环境」统一出口（与构建时的 NODE_ENV 解耦）
 *
 * 背景：
 * - `NODE_ENV` 由 Vue/Webpack 用于 tree-shaking、压缩等；在 test/staging 若仍为 test/staging，
 *   会导致包体异常；开启 `VUE_CLI_OPTIMIZE_BUNDLE` 时产物内可能被覆写为 `production`。
 * - 因此「当前是测试 / 预发 / 正式 / 本地」等判断，不要依赖 `process.env.NODE_ENV`，
 *   应统一使用本文件从 `VUE_APP_RUNTIME_ENV` 读取的值。
 *
 * 配置：在各环境 `.env.*` 中设置 `VUE_APP_RUNTIME_ENV`（如 test、staging、production、development）。
 * 该变量会以 `VUE_APP_` 前缀注入到前端 bundle，构建时可被静态替换为字符串字面量。
 */

/** 当前业务环境标识，与 `.env.*` 中 `VUE_APP_RUNTIME_ENV` 一致 */
export const RUNTIME_ENV = process.env.VUE_APP_RUNTIME_ENV

/**
 * 是否为「正式线上」部署（仅当 VUE_APP_RUNTIME_ENV === 'production'）
 * 用于：埋点区分、正式域名/开关等与用户可见线上行为相关的逻辑。
 */
export function isProductionRuntime() {
  return RUNTIME_ENV === "production"
}

/**
 * 是否为本地开发（serve 时 `.env.development` 中一般为 development）
 */
export function isDevelopmentRuntime() {
  return RUNTIME_ENV === "development"
}

/**
 * 是否为测试环境构建产物（与正式、预发区分）
 */
export function isTestRuntime() {
  return RUNTIME_ENV === "test"
}

/**
 * 是否为预发 / 灰度环境
 */
export function isStagingRuntime() {
  return RUNTIME_ENV === "staging"
}
